/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { selectHasTourAvailability } from '../../../../modules/multifamilyTourTimePicker/selectors'
import { fetchTourIntegration } from '../../../../modules/multifamilyTourTimePicker/thunks/fetchTourAvailability'
import type { GetState } from '../../../../modules/types'

export const getHasInstantTourAvailability =
  (entity: Listable | Property | Pin<RawPinInventorySearch> | null | undefined) =>
  async (dispatch: Dispatch, getState: GetState) => {
    if (!entity) {
      return false
    }
    await dispatch(fetchTourIntegration(entity))
    return selectHasTourAvailability(getState(), entity.groupId)
  }
